const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("../modals/OfficeModal");
const RadioItem = require("../RadioItem");
const Input = require("./Input");
const LoadingCircle = require("../../core/view/LoadingCircle");
const CopyTable = require("../data/CopyTable");

const styles = require("./styles/HearAboutBaSurveyModal.css");

const randomizeOptions = function(options) {
	const other = options.filter(opt => opt.key === "other");
	const rest = options.filter(opt => opt.key !== "other");
	return [..._.shuffle(rest), ...other];
};

const HearAboutBaSurveyModal = createReactClass({
	displayName: "HearAboutBaSurveyModal",

	propTypes: {
		options: PT.arrayOf(
			PT.shape({
				key: PT.string.isRequired,
				label: PT.oneOfType([PT.string, PT.object]).isRequired,
			})
		).isRequired,
		onSubmit: PT.func.isRequired,
		onDismiss: PT.func.isRequired,
		status: PT.string,
	},

	getInitialState: function() {
		return {
			selected: null,
			otherText: "",
		};
	},

	selectOption: function(optionKey) {
		this.setState({selected: optionKey});
	},

	onUpdateOtherText: function(val) {
		this.setState({otherText: val});
	},

	canSubmit: function() {
		return this.state.selected != null && this.props.status !== "pending";
	},

	handleSubmit: function() {
		if (!this.canSubmit()) {
			return;
		}
		this.props.onSubmit({
			optionKey: this.state.selected,
			otherText: this.state.otherText,
		});
	},

	handleKeyPress: function(evt, type) {
		if (evt.which !== 13) {
			return;
		}
		if (type === "submit" && this.canSubmit()) {
			this.handleSubmit();
		}
	},

	render: function() {
		const {options, onDismiss, status} = this.props;
		const {selected, otherText} = this.state;
		const isPending = status === "pending";
		const showOtherInput = selected === "other";

		const optionEls = _.map(options, (option, i) => (
			<div className={styles.option} key={option.key}>
				<RadioItem
					className={styles.radio}
					text={option.label}
					isSelected={selected === option.key}
					size="medium"
					tabIndex={50 + 2 * i}
					onClick={() => this.selectOption(option.key)}
				/>
			</div>
		));

		let otherInput;
		if (showOtherInput) {
			otherInput = (
				<div className={styles.otherInputContainer}>
					<div className={styles.otherInputSpacer} aria-hidden="true" />
					<Input
						key="hear-about-other-input"
						className={styles.otherInput}
						inputClass={styles.otherInputField}
						initialValue={otherText}
						autofocus={true}
						updateOnEdit={true}
						maxLength={2000}
						onUpdate={this.onUpdateOtherText}
					/>
				</div>
			);
		}

		let submitEl;
		if (isPending) {
			submitEl = (
				<div className={styles.submitButtonDisabled}>
					<div className={styles.loading}>
						<LoadingCircle colorType="white" />
					</div>
				</div>
			);
		} else if (this.canSubmit()) {
			submitEl = (
				<div
					className={styles.submitButton}
					onClick={this.handleSubmit}
					tabIndex={70}
					onKeyPress={evt => this.handleKeyPress(evt, "submit")}
				>
					submit
				</div>
			);
		} else {
			submitEl = <div className={styles.submitButtonDisabled}>submit</div>;
		}

		return (
			<OfficeModal
				onClose={onDismiss}
				closeOnEsc={true}
				closeOnBackdropClick={false}
				portalContainer={null}
				level="overBar"
				modalClass={styles.main}
				closeClass={styles.closeBlock}
				closeHideIcons={true}
			>
				<div className={styles.container}>
					<div className={styles.content}>
						<div className={styles.title}>
							{CopyTable.getHearAboutBaSurveyTitleCopy()}
						</div>
						<div className={styles.options}>
							{optionEls}
							{otherInput}
						</div>
					</div>
					<div className={styles.submitRow}>{submitEl}</div>
				</div>
			</OfficeModal>
		);
	},
});

HearAboutBaSurveyModal.randomizeOptions = randomizeOptions;

module.exports = HearAboutBaSurveyModal;
